import React from "react";
import {Modal} from 'antd';
import getSize from "../../../../utils/getSize";
import NHFetch from "../../../../utils/NHFetch";
import css from './index.css';
import JxQueryStudents from "../jxQueryStudents";//基线
import GyQueryStudents from "../gyQueryStudents";//广医
import ScjtQueryStudents from "../scjtQueryStudents";//四川交通
import JhysQueryStudents from "../jhysQueryStudents";//江汉艺术

const confirm = Modal.confirm;

const baseUrlPath = "/swbl/lstd"; //基础路径

/**
 * 通用学生信息查询组件-菜单配置
 * @author liudongbin
 * @date 2021年7月30日 10点24分
 * Version: 1.0
 */
class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
        };
    }

    componentDidMount() {
        this.getMenuCode();
    }

    getMenuCode = () => {
        let cds = ["xsxxcx"];
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    render() {
        const {menuCode} = this.state;
        return (
          <div>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if (item.JC == "gzykdx") {
                          return <GyQueryStudents/>
                      } else if(item.JC == "scjt") {
                          return <ScjtQueryStudents/>
                      } else if(item.JC == "jhyszy") {
                          return <JhysQueryStudents/>
                      } else {
                          return <JxQueryStudents/>
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <JxQueryStudents/>}
          </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/tjcx/queryStudents/tyQueryStudents/index.js